var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatingSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.41 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "heatingsystem"
  }, "Heating System Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "heatingsystem"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.63,48.08H2.73A2.63,2.63,0,0,1,.11,45.45V2.79A2.62,2.62,0,0,1,2.73.17h21.9a2.62,2.62,0,0,1,2.62,2.62V45.45A2.62,2.62,0,0,1,24.63,48.08ZM2.73,1.42A1.37,1.37,0,0,0,1.36,2.79V45.45a1.37,1.37,0,0,0,1.37,1.38h21.9A1.37,1.37,0,0,0,26,45.45V2.79a1.37,1.37,0,0,0-1.37-1.37Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.62,
    y: 5.91,
    width: 16.37,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.74,
    y: 9.74,
    width: 16.37,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.74,
    y: 13.56,
    width: 16.37,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.74,
    y: 17.39,
    width: 16.37,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.62,
    y: 34.33,
    width: 1.71,
    height: 1.71
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.31,
    y: 34.33,
    width: 1.71,
    height: 1.71
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.01,
    y: 34.33,
    width: 1.71,
    height: 1.71
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.34,
    y: 23.39,
    width: 1.71,
    height: 5.37
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 34.33,
    width: 1.71,
    height: 1.71
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4,
    y: 34.33,
    width: 1.71,
    height: 1.71
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 5.62,
    y: 38.24,
    width: 1.71,
    height: 1.71
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 9.31,
    y: 38.24,
    width: 1.71,
    height: 1.71
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 13.01,
    y: 38.24,
    width: 1.71,
    height: 1.71
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 38.24,
    width: 1.71,
    height: 1.71
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4,
    y: 38.24,
    width: 1.71,
    height: 1.71
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 5.62,
    y: 41.66,
    width: 1.71,
    height: 1.71
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 9.31,
    y: 41.66,
    width: 1.71,
    height: 1.71
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 13.01,
    y: 41.66,
    width: 1.71,
    height: 1.71
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 41.66,
    width: 1.71,
    height: 1.71
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4,
    y: 41.66,
    width: 1.71,
    height: 1.71
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatingSystem);
export default __webpack_public_path__ + "static/media/heating-system.91739f1cf669d11b95c48403c897c6d1.svg";
export { ForwardRef as ReactComponent };